import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { withRouter } from 'react-router-dom'
import Paths, { replaceRoute, matches } from '../../router';
import { parseQuery } from '../../util';
import { applyMessages, getDefaultLanguage } from '../../ui/messages'
import { messagesFetch } from '../../routes';
import Table from './table/table';
import Welcome from './welcome';
import JoinTable from './table/joinTable';
import { getStorageValue, StorageFieldDefaults, StorageFields } from '../../storage/browserStorage';

class PageComponent extends React.Component
{

    constructor(props)
    {
        super(props)
        this._badgeIdx = Math.round((this.getBadges().length - 1) * Math.random())
    }

    componentDidMount()
    {
        const query = parseQuery(this.props) || {}
        
        // Check for language settings
        const lang = query.lang
        if (lang != null && lang != getDefaultLanguage()) {
            document.cookie = `lang=${lang}; expires=-1; page=/;`
            messagesFetch(lang, msgs => {
                applyMessages(msgs),
                this.forceUpdate()
            })
        }
    }

    getBadges(isInGame)
    {
        const className = "beta-badge " + (isInGame ? "hidden" : "")
        return [
            <div className={ className }>Ist das<br></br>noch Beta?</div>,
            <div className={ className }>Ansagen<br></br>sind cool</div>,
            <div className={ className }>Ab in den<br></br>Schwarzwald!</div>,
            <div className={ className }>Sagt<br></br>jemand was?</div>,
            <div className={ className }>Nur Schmutz<br></br>auf der Hand!</div>,
            <div className={ className }>100%<br></br>bugfrei!</div>,
            <div className={ className }>Nnnnnnng<br></br>gut</div>,
            <div className={ className }>Re muss<br></br>ansagen!</div>,
            <div className={ className }>Zeit für<br></br>kein Solo!</div>,
            <div className={ className }>Schlecht<br></br>gespielt!</div>,
            <div className={ className }>Super-<br></br>Schwein??</div>
        ]
    }

    render()
    {
        const isInGame = matches(this.props.location, Paths.Table.TABLE);

        return (
            <div key="page" className='page'>
                <div className={ "page-background" + (isInGame ? " table" : "")
                    + (" background-" + (getStorageValue(StorageFields.BACKGROUND_STYLE))) } />
                <div className={ "page-vignette" + (isInGame ? " table" : "") } />
                <Route path={ Paths.Table.TABLE } component={ Table } />
                <div className={ "menu-shadow" + (isInGame ? " hidden" : "") } />
                <div className={ "menu-container" }>
                    <div className={ "menu" + (isInGame ? " hidden" : "") }>
                        <div className="menu-content">
                            <Switch>
                                <Route path={ Paths.Table.JOIN } exact component={ JoinTable } />
                                <Route path={ Paths._PATH } component={ Welcome } />
                            </Switch>
                        </div>
                    </div>
                </div>
                { this.getBadges(isInGame)[this._badgeIdx] }
            </div>
        )
    }

}

export const Page = withRouter(PageComponent)

export default Page